import React, { FC, useEffect } from "react";
import MyParty from "../components/MyParty";
import NoPartyBanner from "../components/NoPartyBanner";
import PartyTabSkeleton from "../components/GuestMode/PartyTabSkeleton";
import { PartyModel } from "../types";

interface MyPartiesContentProps {
  isLoadingParties: boolean;
  myPartiesInfo: PartyModel[];
  SetMyPartiesCount: (length: number) => void;
}

const MyPartiesContent: FC<MyPartiesContentProps> = ({
  isLoadingParties,
  myPartiesInfo,
  SetMyPartiesCount,
}) => {
  useEffect(() => {
    if (!isLoadingParties) {
      SetMyPartiesCount(myPartiesInfo.length);
    }
  }, [isLoadingParties, myPartiesInfo.length, SetMyPartiesCount]);

  if (isLoadingParties) {
    return <PartyTabSkeleton />;
  }

  if (myPartiesInfo.length > 0) {
    return (
      <div>
        {myPartiesInfo.map((party: PartyModel) => (
          <MyParty key={party.party.id} party={party} />
        ))}
      </div>
    );
  }

  return <NoPartyBanner />;
};

export default MyPartiesContent;
